import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_change",
  "use": "icon-project_change-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_change\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M9 20.045V24l-8-7 8-7v4.023\" /><path d=\"M17 14H9M17 20H9\" /><g><path stroke-linejoin=\"round\" d=\"M19 14.045V18l8-7-8-7v4.023\" /><path d=\"M11 8h8M11 14h8\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol